import type { HTMLAttributes, ReactElement, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import cx from 'clsx';
import { IconTrashOutlined } from '@repo/monochrome-icons';
import { Button } from 'react-aria-components';
import styles from '../attachment.module.css';

interface LayoutProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  endContent?: ReactNode;
  icon: ReactNode;
  onRemove?: () => void;
}

export function Layout({
  children,
  className,
  endContent,
  icon,
  onRemove,
  ...props
}: LayoutProps): ReactElement {
  const { formatMessage } = useIntl();

  return (
    <div className={cx(styles.attachment, className)} {...props}>
      {icon}

      <div className={styles.info}>{children}</div>

      {endContent}

      {onRemove ? (
        <Button
          aria-label={formatMessage({ id: 'a11y-buttons-remove-file-aria-label' })}
          className={styles.removeButton}
          onPress={onRemove}
          type="button"
        >
          <IconTrashOutlined />
        </Button>
      ) : null}
    </div>
  );
}
